
import { defineComponent, onMounted, reactive } from "vue";
import SelectedHospital from "@/components/common/SelectedHospital.vue";
import SecondOpinionRequest from "@/components/secondOpinion/SecondOpinionRequest.vue";

export default defineComponent({
  name: "Second Opinion Request",

  setup() {
    const state = reactive({
      selectHospital: null as null | Number,
      isLoading: true,
    });

    onMounted(() => {
      state.selectHospital =
        process.env.VUE_APP_IS_SELECTHOSPITAL === "true" ? null : 0;

      state.isLoading = false;
    });

    return {
      state,
    };
  },

  components: {
    SelectedHospital,
    SecondOpinionRequest,
  },
});
